import type { LandingSpinResult } from '@/lib/landing-roulette'
import type { LandingPendingCouponPrize } from '@/lib/landingCampaignWidget'

function getPayloadNumber(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number.parseFloat(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}

function getPayloadString(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed !== '' ? trimmed : null
}

export function buildPendingCouponFromSpinResult(
  result: LandingSpinResult
): LandingPendingCouponPrize | null {
  if (result.prize_type !== 'coupon') return null

  const payload = result.prize_payload ?? {}
  const code = getPayloadString(payload.code)
  if (!code) return null

  const label =
    getPayloadString(payload.description) ??
    getPayloadString(payload.label) ??
    'Cupom de desconto'

  const discountPercent = getPayloadNumber(payload.discount_percent)
  const discountAmount = getPayloadNumber(payload.discount_amount)
  const minPurchase = getPayloadNumber(payload.min_purchase)

  return {
    code,
    label,
    ...(discountPercent !== null ? { discount_percent: discountPercent } : {}),
    ...(discountAmount !== null ? { discount_amount: discountAmount } : {}),
    ...(minPurchase !== null ? { min_purchase: minPurchase } : {}),
  }
}
